import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ReportCloneFacade, ReportFacade, ReportParameterOptionsFacade } from '@mode/reports/domain';

export const DowngradedReportsDomainModule = angular
  .module('downgraded-reports-domain', [])
  .service('ReportFacade', downgradeInjectable(ReportFacade))
  .service('ReportCloneFacade', downgradeInjectable(ReportCloneFacade))
  .service('ReportParameterOptionsFacade', downgradeInjectable(ReportParameterOptionsFacade)).name;
